import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Realm } from '../../classes/realm';
import { RealmType, RealmTypePresentation } from '../../enums/realm-type.enum';


@Component({
  selector: 'app-realms-dropdown',
  templateUrl: './realms-dropdown.component.html',
  styleUrls: ['./realms-dropdown.component.scss'],
  standalone: false
})
export class RealmsDropdownComponent {
  public readonly RealmType = RealmType;
  public readonly RealmTypePresentation = RealmTypePresentation;
  public readonly orderedRealmTypes = [RealmType.Idaas, RealmType.Enterprise];

  @Input()
  public realms: Realm[];

  @Input()
  public currentRealm: Realm;

  @Output()
  public realmChanged: EventEmitter<Realm> = new EventEmitter();


  public get multipleRealmTypes(): boolean {
    return new Set(this.realms?.map(realm => realm.type)).size > 1;
  }

  public realmsByType(type: RealmType): Realm[] {
    return this.realms?.filter(realm => realm.type === type) ?? [];
  }

  public selectRealm(realm: Realm) {
    this.realmChanged.emit(realm);
  }
}
